import { API_BASE_URL } from "../props";
import { useDelete, useGet, usePut, useUpload } from "../common/fetchServices";

const getBadgesUrl = () => `${API_BASE_URL}/admin/badges`;
const getContentBadgesUrl = mediaId =>
  `${API_BASE_URL}/admin/media/${mediaId}/badges`;
const getContentBadgeUrl = ({ mediaId, badgeId }) =>
  `${API_BASE_URL}/admin/media/${mediaId}/badges/${badgeId}`;
const getBadgesUpdateUrl = ({ id }) => `${API_BASE_URL}/admin/badges/${id}`;
const getBadgeUploadUrl = ({ type }) => `${API_BASE_URL}/admin/badges/${type}`;

export const useBadges = () => {
  const url = getBadgesUrl();
  return useGet(["badges"], url);
};

export const useContentBadges = mediaId => {
  const url = getContentBadgesUrl(mediaId);
  return useGet(["content-badges", { id: mediaId }], url);
};

export const useLinkBadgeToContent = () => {
  return usePut(getContentBadgeUrl, {
    queriesToInvalidate: [["content-badges", ["id"]]],
  });
};

export const useUnlinkBadgeFromContent = () => {
  return useDelete(getContentBadgeUrl, {
    queriesToInvalidate: [["content-badges", ["id"]]],
  });
};

export const useUpdateBadge = () => {
  return usePut(getBadgesUpdateUrl, {
    queriesToInvalidate: [["badges"]],
  });
};

export const useUploadBadge = () => {
  return useUpload(getBadgeUploadUrl, {
    props: {
      method: "POST",
    },
    queriesToInvalidate: [["badges"]],
  });
};
